import { NewAlertMessage } from "../hooks/useSystemAlerts";
import { ApiResponse, BaseResponse, BaseResponseWithData, baseUrl, GetParams, getWithAuth, getWithAuthAndParams, Guid, ListRespone, PaginationListRespone, postWithAuth } from "./baseApi";

export interface SystemAlertModel {
    id:Guid,
    dateTime: string,
    message: string,
    severity: SeverityType,
    isRead: boolean,
    group: AlertGroup,
    byUser: string,
}

export enum AlertGroup {
    System = 0,
    User = 1,
    Campaign = 2,
    Site = 3
}

export enum SeverityType {
    Info = 0,
    Warning = 1,
    Important = 2,
}

export interface UnreadCountResponse {
    count:number,
    newMessages: NewAlertMessage [] 
}

export const getSystemAlertsWithParams = async(page:number, severity: SeverityType, onlyUnready: boolean, searchString: string, alertGroup: AlertGroup | undefined) : Promise<ApiResponse<PaginationListRespone<SystemAlertModel>>> => {
    let params = new GetParams();
    params.Add("page", page+'');
    params.Add("minimumSeverity", severity+'');
    params.Add("onlyUnready", onlyUnready+'')
    if (alertGroup != null) {
        params.Add("alertGroup", alertGroup+'')
    }
    params.Add("searchString", searchString)
    return await getWithAuthAndParams<PaginationListRespone<SystemAlertModel>>(`${baseUrl}alert`, params);
}

export const getSystemAlertsUnreadCount = async() : Promise<ApiResponse<BaseResponseWithData<UnreadCountResponse>>> => {
    return await getWithAuth<BaseResponseWithData<UnreadCountResponse>>({ url: `${baseUrl}alert/count-unread`});
}

export const updateSystemAlertStatus = async (id:Guid, request: {}) : Promise<ApiResponse<BaseResponse>> => {
    return await postWithAuth<{}, BaseResponse>(`${baseUrl}alert/${id}/mark-as-read`, request)
}

export const updateAllSystemAlertAsReaded = async (request: {}) : Promise<ApiResponse<BaseResponse>> => {
    return await postWithAuth<{},BaseResponse>(`${baseUrl}alert/mark-as-read`, request)
}